<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  /* 藏品列表卡片背景图 */
  --card-bgi: url('https://guide.rzsbwg.com/wxapp_image/icon/box_bgi.png');
  /* 展览首页卡片背景图 */
  --exhibition-card-image: url('https://guide.rzsbwg.com/wxapp_image/icon/box_bgi_2.png');
  /* 我的足迹背景图片 */
  --foot-point-bg: url('https://guide.rzsbwg.com/wxapp_image/icon/footer_bgi.png');
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  --font-theme-color: #992e2d;
  color: #232323;
  /* margin-top: 60px; */
}
.rich_text {
  font-size: 32px;
  line-height: 46px;
  letter-spacing: 2px;
}
/* 间隔 */
.common-line {
  width: 750px;
  height: 20px;
  background: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue